import type { ConfigTemplateApplyResult, ConfigTemplateLevel } from '../../../types/configTemplate.types';
import { applyReceiptBody, applyReceiptTitle } from '../configTemplateCopy';

interface ApplyReceiptProps {
    level: ConfigTemplateLevel;
    result: ConfigTemplateApplyResult;
}

function CheckIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function AlertIcon() {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
            <circle cx="12" cy="12" r="9" />
        </svg>
    );
}

export default function ApplyReceipt({ level, result }: ApplyReceiptProps) {
    const failed = result.failed.length;
    const written = result.applied.length;
    const warning = failed > 0;
    return (
        <div
            className="flex items-start"
            style={{
                gap: 10,
                padding: '10px 12px',
                borderRadius: 10,
                background: warning ? 'var(--cpm-warning-bg)' : 'var(--cpm-success-bg)',
                border: `1px solid ${
                    warning ? 'var(--cpm-warning-border)' : 'var(--cpm-success-border)'
                }`,
                color: warning ? 'var(--cpm-warning-icon)' : 'var(--cpm-success-text-light)',
            }}
        >
            <span className="flex-none" style={{ paddingTop: 1 }}>
                {warning ? <AlertIcon /> : <CheckIcon />}
            </span>
            <div className="min-w-0 flex-1 flex flex-col" style={{ gap: 2 }}>
                <div
                    style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: warning ? 'var(--cpm-warning-text)' : 'var(--cpm-success-text)',
                    }}
                >
                    {applyReceiptTitle(level, written, failed)}
                </div>
                <div
                    style={{
                        fontSize: 12.5,
                        fontWeight: 600,
                        lineHeight: 1.45,
                        color: warning ? 'var(--cpm-warning-text-med)' : 'var(--cpm-success-text)',
                    }}
                >
                    {applyReceiptBody(failed)}
                </div>
            </div>
        </div>
    );
}
